import { isStringEmpty } from './string';

const UUID_LENGTH = 36;

const isUUID = (uuid: string | undefined | null) =>
  !isStringEmpty(uuid) && uuid!!.length === UUID_LENGTH;

export { UUID_LENGTH, isUUID };
